import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query GetChannelsGroups {
  channelsGroups {
    id
    name
    description
    config
    channels {
      id
      name
    }
    groupUsers {
      id
    }
  }
}`;

function getChannelsGroups() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => (res.data.channelsGroups))
    .then((channelsGroups) => channelsGroups.map((channelsGroup) => ({
      ...channelsGroup,
      config: JSON.parse(channelsGroup.config),
    })));
}

export default getChannelsGroups;
